import React from "react";
import classNames from "classnames";
import { CloseCrossIcon } from "@/shared/icons";
import type { BookmarkTabsImprovedProps } from "./types";
import { AppButton } from "../AppButton";
import styles from "./styles.module.scss";

export const BookmarkTabsImproved: React.FC<BookmarkTabsImprovedProps> = ({
  tabs,
  activeKey,
  onTabChange,
  onTabClose,
  isEditable = false,
  extraContent,
  isContactsPage = false,
  disabledKeys = [],
}) => {
  const handleTabClick = (key: string) => {
    if (disabledKeys.includes(key)) return;
    onTabChange(key);
  };

  const handleTabClose = (key: string) => {
    onTabClose && onTabClose(key);
  };

  return (
    <div className={styles.container}>
      <div className={styles["tabs-wrapper"]}>
        {tabs.map((tab) => (
          <div
            key={tab.key}
            onClick={() => handleTabClick(tab.key)}
            className={classNames(styles.tab, {
              [classNames(styles["active-tab"])]: activeKey === tab.key,
              [classNames(styles["tab--disabled"])]: disabledKeys.includes(tab.key),
            })}
          >
            <div className={styles.inner}>
              {tab.label}
              {isEditable && (
                <AppButton
                  className={styles["close-button"]}
                  onClick={(e) => {
                    e.stopPropagation();
                    handleTabClose(tab.key);
                  }}
                >
                  <CloseCrossIcon />
                </AppButton>
              )}
            </div>
          </div>
        ))}
      </div>
      {extraContent && <div className={styles["extra-content"]}>{extraContent}</div>}
      <div
        className={classNames(styles["content-wrapper"], {
          [styles["content-wrapper--contacts"]]: isContactsPage,
        })}
      >
        {tabs.find((tab) => tab.key === activeKey)?.children}
      </div>
    </div>
  );
};
